import React, { forwardRef } from "react";
import styles from "./style.module.css";
import Spinner from "../spinner";

export type ButtonVariant = "primary" | "secondary" | "tertiary";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  variant?: ButtonVariant;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    label,
    variant = "primary",
    onClick,
    disabled = false,
    type = "button",
    className = "",
    loading = false,
    ...restProps
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      ref={ref}
      type={type}
      className={`${styles.button} ${styles[`button--${variant}`]} ${
        disabled ? styles["button--disabled"] : ""
      } ${className}`}
      onClick={handleClick}
      disabled={disabled}
      aria-disabled={disabled}
      {...restProps}
    >
      <span className={styles.button__label}>
        {loading ? <Spinner color={variant === "primary" ? "black" : "white"}/> : label}
      </span>
    </button>
  );
});

Button.displayName = "Button";

export default Button;